import * as React from 'react'

import OurMallsModal from '../../../../components/home/OurMallsModal/OurMallsModal'

class MallModalPreview extends React.Component {
  render() {
    const { mallPreview = {} } = this.props
    return (
      <OurMallsModal
        malls={[mallPreview]}
        show={true}
        currentMall={mallPreview}
      />
    )
  }
}

MallModalPreview.defaultProps = {
  // TODO: specify default props
}

MallModalPreview.propTypes = {
  // TODO: specify prop types
}

export default MallModalPreview
